<script>
import TopBlockCard from "@/components/HomePageView/TopBlockCard.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import {useSettingsStore} from "@/store/settings";

export default {
  name: "TopBlock",
  components: {ActionButton, TopBlockCard},
  setup() {
    const settings = useSettingsStore();

    function openBotHandler() {
      window.open('https://t.me/Kiberded_otvet_bot', '_blank');
    }
    return {
      settings, openBotHandler
    }
  }
}
</script>

<template>
  <div class="topBlock">
    <TopBlockCard class="topBlock__cardMain">
      <template #header>5,321 участник | 47 мероприятий в год</template>
      <template #content>
        <div class="topBlock__content1">
          <span>« OSINT — это оружие. Научись им владеть »</span>
          <img  class="topBlock__img1" :src="require('@/assets/img/2022-12-210.png')" alt="">
        </div>
      </template>
      <template #buttons>
        <ActionButton
            @buttonClick="$router.push({name: 'ClubView'})"
        >
          <template #caption>О клубе</template>
        </ActionButton>
        <ActionButton
            v-if="!settings.user.is_at_club"
            icon-type="arrow"
            @buttonClick="$router.push({name: 'ClubSignUpView'})"
        >
          <template #caption>Вступить</template>
        </ActionButton>
      </template>

    </TopBlockCard>
    <TopBlockCard class="topBlock__cardSecondary">
      <template #header>Спроси коротко, по делу, без херни.</template>
      <template #content>Есть вопрос Кибердеду?</template>
      <template #buttons>
        <ActionButton icon-type="arrow"
          @buttonClick="openBotHandler"
        >
          <template #caption>Спросить в боте</template>
        </ActionButton>
      </template>
    </TopBlockCard>
  </div>
</template>

<style lang="scss" scoped>
.topBlock {
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  gap: 17px;
  flex-grow: 1;
  margin: 24px 0;

  @include respond-to('lg') { flex-wrap: wrap; }
  @include respond-to('md') { flex-direction: column; }

  &__cardMain {
    width: 914px;
    min-height: 308px;

    @include respond-to('xl') { width: auto; flex: 2 1 500px; }
    @include respond-to('lg') { width: 100%; flex: 1 1 100%; min-height: 260px; }
  }

  &__cardSecondary {
    width: 429px;
    min-height: 308px;

    @include respond-to('xl') { width: auto; flex: 1 1 280px; }
    @include respond-to('lg') { width: 100%; flex: 1 1 100%; min-height: 200px; }
  }

  &__content1 {
    display: flex;
    max-width: 570px;
    width: 100%;
    overflow: hidden;
  }

  &__img1 {
    position: absolute;
    top: -50px;
    right: 0;
    max-width: 45%;
    height: auto;

    @include respond-to('md') { display: none; }
  }
}
</style>
